<template>
  <div class="bestSell">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="bgcolor">
        <img src="../../assets/images/bestsellheader.png">
        <p @click="screen">筛选 <img src="../../assets/images/jt.png"></p>
        <div class="tags">
          <b>畅销榜</b><span>按照商品的{{eleIndexTime == 0 ? '周销量' : eleIndexTime == 1 ? '月销量' : '年销量'}}{{eleIndexSort == 0 ? '综合' : eleIndexSort == 1 ? '销量降序' : eleIndexSort == 2 ? '价格升序' : '评价降序'}}排序
        </span>
        </div>
      </div>
      <ul>
        <li v-for="(item, index) of list" :key="index" @click="beSellClick(item)">
          <img v-lazy="item.img_path">
          <div class="proContent">
            <p>{{item.name.length > 23 ? item.name.slice(0, 23) + '...' : item.name}}</p>
            <div class="tags">
              <b v-if="item.tag1"><img src="../../assets/images/fire1.png">{{item.tag1}}</b>
              <b v-if="item.tag2"><img src="../../assets/images/fire1.png">{{item.tag2}}</b>
              <b v-if="item.tag3"><img src="../../assets/images/fire1.png">{{item.tag3}}</b>
            </div>
            <span class="salesStatus">已售{{parseFloat(item.sales_num) / 10000 >= 1 ? (parseInt(parseInt(item.sales_num) / 100) / 100).toFixed(2) + 'w' : item.sales_num}}&nbsp;&nbsp;|&nbsp;&nbsp;好评{{item.comment_num}}</span>
            <div class="span">
              <div class="goods_price nowPrice">
                    <span class="smallprice">
                      <sub>¥</sub>
                      <b>{{String(item.sales_price).slice(0, String(item.sales_price).indexOf('.'))}}</b>
                      <sup>{{String(item.sales_price).slice(String(item.sales_price).indexOf('.'), String(item.sales_price).length)}}</sup>
                    </span>
              </div>
              <!--<span class="nowPrice">-->
                <!--{{String(item.sales_price).slice(0, String(item.sales_price).indexOf('.'))}}-->
                <!--<i>-->
                  <!--{{String(item.sales_price).slice(String(item.sales_price).indexOf('.'), String(item.sales_price).length)}}-->
                <!--</i>-->
              <!--</span>-->
              <div class="goods_price beforePrice">
                    <span class="smallprice">
                      <b>¥{{item.cost_price}}</b>
                    </span>
              </div>
              <!--<span class="beforePrice">-->
                <!--{{String(item.cost_price).slice(0, String(item.cost_price).indexOf('.'))}}-->
                <!--<i>-->
                 <!--{{String(item.cost_price).slice(String(item.cost_price).indexOf('.'), String(item.cost_price).length)}}-->
                <!--</i>-->
              <!--</span>-->
            </div>
            <img @click.stop="openSku(item, index)" src="../../assets/images/shopping.png">
          </div>
          <img v-if="index == 0" class="tagimg" :src="require('../../assets/images/tagtop1.png')">
          <img v-else-if="index == 1" class="tagimg" :src="require('../../assets/images/tagtop2.png')">
          <img v-else-if="index == 2" class="tagimg" :src="require('../../assets/images/tagtop3.png')">
        </li>
      </ul>
    </Scroller>
    <van-sku
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :quota-used="quotaUsed"
      :goods-id="productId"
      :quota="quota"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture">
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{goods.title}}</div>
            <div class="van-sku-header-item">{{skuname == ''?'请选择商品规格':'已选 '+skuname}}</div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span><span class="van-sku__price-num">{{skuprice}}</span>
            </div>
            <!--<i class="van-icon van-icon-clear van-sku__close-icon" @click="showsku = false"></i>-->
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            size="large"
            type="danger"
            class="sure"
            :class="{'sureGray': sureGray}"
            @click="onConfirmClicked"
          >
            确定
          </van-button>
        </div>
      </template>
    </van-sku>
    <transition name="slide-fade">
      <div v-if="floatWindowShow" class="FloatWindow">
      <p @click="screen">筛选 <img src="../../assets/images/jt7.png"></p>
      <div class="classification">
        <p>排序</p>
        <ul>
          <li @click="elementClickSort(index)" :class="{elements: index!=eleIndexSort, tempElements: index==eleIndexSort}" v-for="(item, index) in domList[0].sort" :key="index">{{item}}</li>
        </ul>
      </div>
      <div class="classification">
        <p>时间</p>
        <ul>
          <li @click="elementClickTime(index)" :class="{elements: index!=eleIndexTime, tempElements: index==eleIndexTime}" v-for="(item, index) in domList[0].time" :key="index">{{item}}</li>
        </ul>
      </div>
      <div class="btn">
        <button class="element" @click="reset">重置</button>
        <button class="element" @click="confirm">确定</button>
      </div>
    </div>
    </transition>
    <transition name="fade">
      <div @click="screen" v-if="floatWindowShow" class="mask"></div>
    </transition>
    <div class="homeBtn" @click="shopClick">
      <img src="/static/images/goshop.png">
      <div class="cartnum" v-if="cartnum > 0">{{cartnum > 99 ? '...' : cartnum}}</div>
    </div>
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import { kefu, fenxiang, isWeixin, appid } from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
import { Sku } from 'vant'
export default {
  name: 'bestSell',
  components: {
    [Sku.name]: Sku,
    Scroller
  },
  data () {
    return {
      list: [],
      domList: [
        {
          sort: ['综合排序', '销量降序', '价格升序', '评价降序'],
          time: ['周榜', '月榜', '年榜']
        }
      ],
      eleIndexSort: 0,
      eleIndexTime: 0,
      floatWindowShow: false,
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      daiIndex: 0,
      zcIndex: 0,
      sureGray: false,
      skuprice: '197.00-218.90',
      skuId: null, // 总规格id 注： 传给后端的参数
      itemnum: null, // 购买数量 注：传给后端的参数
      productId: null,
      showsku: false,
      skuname: '',
      i: 0,
      quota: 0,
      quotaUsed: 0,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      listItem: {},
      itemIndex: null,
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const {action, limitType, quota, quotaUsed} = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            // let msg = `单次限购${quota}件`;
            // if (quotaUsed > 0) msg += `，你已购买${quotaUsed}`;
            let msg = `数量超出范围~`
            this.$toast(msg);
          }
        },
        handleStepperChange: currentValue => {
        },
        stockNum: 0,
        stockFormatter: stockNum => {
        }
      },
      productNum: 0,
      skuValueToast: null,
      cartnum: 0
    }
  },
  mounted: function () {
    // this.nowPage = 1
    // this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/' && from.name != 'homePage') { // 当前页面刷新不需要切换位置
      // sessionStorage.askPositon = ''
      next(vm => {
        Object.assign(vm.$data, vm.$options.data());
      })
    } else {
      next(vm => {
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getData: function () {
      var url = 'Wxmall/Adactinfo/getSalseRankList?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&sort=' + parseInt(this.eleIndexSort + 1) + '&time=' + parseInt(this.eleIndexTime + 1)
      fenxiang({ path: 'bestsell'})
      var that = this
      customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.cartnum = res.data.cartnum ? parseInt(res.data.cartnum) : 0
          if (that.nowPage === 1) {
            that.list = res.data.itemlist
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.itemlist)
          }
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    cartNum: function () {
      var that = this
      var url = 'Wxmall/Adactinfo/getSalseRankList?pageno=1' + '&pagesize=1&sort=' + parseInt(this.eleIndexSort + 1) + '&time=' + parseInt(this.eleIndexTime + 1)
      customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.cartnum = res.data.cartnum ? parseInt(res.data.cartnum) : 0
        }
      })
    },
    elementClickSort: function (idx) {
      this.eleIndexSort = idx
    },
    elementClickTime: function (idx) {
      this.eleIndexTime = idx
    },
    // 重置按钮点击
    reset: function () {
      this.eleIndexSort = 0
      this.eleIndexTime = 0
    },
    // 浮窗的展现形式
    screen: function () {
      this.floatWindowShow = !this.floatWindowShow
      if (!this.floatWindowShow) {
        this.eleIndexSort = null
        this.eleIndexTime = null
      } else {
        // this.reset()
      }
    },
    // 确定按钮点击
    confirm: function () {
      this.floatWindowShow = false
      this.nowPage = 1
      this.getData()
    },
    beSellClick: function (items) {
      this.$router.push({path: '/productdetail',
        query: {
          itemid: items.itemid
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    openSku (items, idx) {
      var that = this
      that.daiIndex = 0
      that.zcIndex = 0
      items.sku_rule_list.map(function (item) {
        if (item.issale == 1 && item.canbuycnt > 0) {
          if (item.islimit == 1) { // 待售
            that.daiIndex++
          } else if (item.islimit == 0) {
            that.zcIndex++
          }
        }
      })
      if (that.zcIndex <= 0 && that.daiIndex <= 0) {
        this.$toast('当前商品无货')
        return
      }
      this.productNum = items.num
      this.listItem = items
      this.itemIndex = idx
      this.productId = this.listItem.itemid
      this.maxNum = parseInt(this.listItem.canbuycnt)
      this.goods.title = items.name
      this.skuprice = parseFloat(items.sales_price).toFixed(2)
      this.goods.picture = items.img_path
      this.skuname = items.spec
      // console.log('skuValueToast:', that.skuValueToast)
      if (!that.skuValueToast || !that.skuValueToast.selectedSkuComb || that.skuValueToast.selectedSkuComb.stock_num <= 0) {
        that.goods.picture = items.img_main_path
        that.skuname = ''
        that.sureGray = true
        that.i = 0
      }
      if (!isWeixin()) {
        if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
          that.$store.commit('PATH_VALUE', JSON.stringify({itemid: that.$route.query.itemid}))
          that.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          that.sku.list = []
          that.sku.tree = []
          items.normlist.map(function (item, index) {
            that.sku.tree.push({
              k: item.spec_classify_name,
              v: [],
              k_s: 's' + (index + 1)
            })
            item.speclist.map(function (itemSon) {
              that.sku.tree[index].v.push({
                id: itemSon.spec_id,
                name: itemSon.spec_name
              })
            })
          })
          items.sku_rule_list.map(function (item) {
            // if (item.issale === 1 && item.islimit === 0) {
            var stockNum = item.issale == 0 || item.islimit == 2 || item.is_can_buy == 0 ? 0 : parseInt(item.canbuycnt)
            that.sku.list.push({
              id: item.skuid,
              price: item.sales_price,
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              payfreight: item.freightrule.payfreight,
              isdiscount: item.isdiscount,
              isfullgift: item.isfullgift,
              ispresale: item.ispresale,
              presaletime: item.presaletime,
              stock_num: stockNum
            })
            if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
              if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
                that.skuValueToast.selectedSkuComb.stock_num = stockNum
                if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
                  that.goods.picture = items.img_main_path
                  that.skuname = ''
                  that.sureGray = true
                }
              }
            }
            that.sku.stock_num += stockNum
            if (stockNum > 0) {
              that.skuname = item.sku_name
              that.goods.picture = item.spec_imgpath
              that.goods.isdiscount = item.isdiscount
              that.goods.isfullgift = item.isfullgift
              that.goods.payfreight = item.freightrule.payfreight
              that.goods.ispresale = item.ispresale
              that.goods.presaletime = item.presaletime
              that.initialSku = {
                s1: item.spec_group_id.split('_')[0],
                s2: item.spec_group_id.split('_')[1],
                s3: item.spec_group_id.split('_')[2],
                payfreight: item.freightrule.payfreight,
                isdiscount: item.isdiscount,
                isfullgift: item.isfullgift,
                ispresale: item.ispresale,
                presaletime: item.presaletime,
                selectedNum: 1
              }
            }
            // }
          })
          // console.log('this.skuprice:', that.skuprice)
          this.showsku = true
        }
      } else {
        that.sku.tree = []
        that.sku.list = []
        items.normlist.map(function (item, index) {
          that.sku.tree.push({
            k: item.spec_classify_name,
            v: [],
            k_s: 's' + (index + 1)
          })
          item.speclist.map(function (itemSon) {
            that.sku.tree[index].v.push({
              id: itemSon.spec_id,
              name: itemSon.spec_name
            })
          })
        })
        items.sku_rule_list.map(function (item) {
          // if (item.issale === 1 && item.islimit === 0) {
          var stockNum = item.issale == 0 || item.islimit == 2 ? 0 : parseInt(item.canbuycnt)
          that.sku.list.push({
            id: item.skuid,
            price: item.sales_price,
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            isdiscount: item.isdiscount,
            isfullgift: item.isfullgift,
            ispresale: item.ispresale,
            presaletime: item.presaletime,
            stock_num: stockNum
          })
          if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
            if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
              that.skuValueToast.selectedSkuComb.stock_num = stockNum
              if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
                that.goods.picture = items.img_main_path
                that.skuname = ''
                that.sureGray = true
              }
            }
          }
          that.sku.stock_num += stockNum
          if (stockNum > 0 && that.i == 0) {
            that.skuname = item.sku_name
            that.goods.picture = item.spec_imgpath
            that.goods.isdiscount = item.isdiscount
            that.goods.isfullgift = item.isfullgift
            that.goods.payfreight = item.freightrule.payfreight
            that.goods.ispresale = item.ispresale
            that.goods.presaletime = item.presaletime
            that.initialSku = {
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              payfreight: item.freightrule.payfreight,
              isdiscount: item.isdiscount,
              isfullgift: item.isfullgift,
              ispresale: item.ispresale,
              presaletime: item.presaletime,
              selectedNum: 1
            }
            that.i = 1
          } else if (stockNum <= 0 && that.i == 0) {
            that.skuprice = parseFloat(items.sales_price).toFixed(2)
            // if (parseFloat(items.sales_top_price) != parseFloat(items.sales_bottom_price)) {
            //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2) + '-' + parseFloat(items.sales_top_price).toFixed(2)
            // } else {
            //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2)
            // }
            // that.initialSku = {}
            that.i = 1
          }
          // }
        })
        this.showsku = true
      }
    },
    checkedSku (skuValue) {
      if (!skuValue.selectedSkuComb) {
        this.sureGray = true
      } else {
        this.sureGray = false
      }
      this.skuValueToast = skuValue
      if (skuValue.selectedSkuComb) {
        this.customStepperConfig.stockNum = this.quota = skuValue.selectedSkuComb.stock_num
      } else {
        this.customStepperConfig.stockNum = this.quota = 0
      }
      var skuStr = ''
      this.skuname = ''
      var len = this.listItem.sku_rule_list
      var skuIndex = 0
      var index = 0
      this.goods.isdiscount = 0
      this.goods.isfullgift = 0
      this.goods.payfreight = 0
      this.goods.ispresale = 0
      this.goods.presaletime = ''
      Object.keys(skuValue.selectedSku).forEach(function (key) {
        skuIndex++
        if (skuValue.selectedSku[key] != '') {
          skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
          index++
        }
      })
      if (index == skuIndex) {
        for (var i = 0; i < len.length; i++) {
          if (len[i].spec_group_id == skuStr) {
            this.skuname = len[i].sku_name
            this.goods.picture = len[i].spec_imgpath
            this.goods.isdiscount = len[i].isdiscount
            this.goods.isfullgift = len[i].isfullgift
            this.goods.payfreight = len[i].freightrule.payfreight
            this.goods.ispresale = len[i].ispresale
            this.goods.presaletime = len[i].presaletime
            if (skuValue.selectedSkuComb !== null) {
              this.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
            }
            break
          }
        }
      } else {
        this.skuprice = parseFloat(this.listItem.sales_price).toFixed(2)
        // if (this.listItem.sales_low_price != this.listItem.sales_high_price) {
        //   this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2) + '-' + parseFloat(this.listItem.sales_high_price).toFixed(2)
        // } else {
        //   this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2)
        // }
      }
      console.log(skuValue, 'that.initialSku', this.initialSku)
    },
    onConfirmClicked () {
      if (this.sureGray) {
        return
      }

      // 1立即购买，0加入购物车
      this.dataCollection()
      var skuData = this.$refs.sku.getSkuData()
      var that = this
      if (skuData.selectedSkuComb !== null) {
        that.showsku = false
        that.skuId = skuData.selectedSkuComb.id
        if (skuData.selectedNum == 0) {
          skuData.selectedNum = 1
        }
        that.itemnum = skuData.selectedNum
        var urlShop = 'Wxmall/ShoppingCart/addShoppingCart'
        var data = {
          skuid: that.skuId,
          itemnum: that.itemnum
        }

        if (this.$route.query.shareOpenid && this.$route.query.shareOpenid != appid) {
          data.shareOpenid = this.$route.query.shareOpenid
        }
        console.log('appid', appid)
        console.log('shareOpenid', this.$route.query.shareOpenid)
        console.log(data)
        customRequestAjax.post(urlShop, data).then(res => {
          if (res.data.code === 200) {
            that.$store.commit('ADD_CART_INIT_DATA', 1)
            that.$toast('已成功加入购物车')
            that.cartNum()
          }
        })
      }
    },
    // 埋点
    dataCollection () {
      let params = {
        'productId_var': this.listItem.itemid,
        'productName_var': this.listItem.name,
        'firstCat_var': this.listItem.brand,
        'productType_var': '',
        'productFormat_var': this.skuId
      }
      console.log('addToCart', params)
      gio('track', 'addToCart', params)
    },
    shopClick: function () {
      this.$router.push({
        path: '/cart'
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .bestSell {
    min-height: 100%;
    background: #fff;
    .bgcolor {
      position: relative;
      font-size: 0;
      >img {
        width: 100%;
      }
      p{
        position: absolute;
        right: 0.11rem;
        top: 0.15rem;
        color: #fff;
        font-size: 0.13rem;
        line-height: 0.18rem;
        img {
          margin: 0.06rem 0 0.06rem 0.04rem;
          width: 0.08rem;
          height: 0.06rem;
          float: right;
        }
      }
      .tags {
        display: inline-block;
        padding: 0.02rem 0.14rem;
        position: absolute;
        bottom: 0.26rem;
        left: 50%;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        -o-transform: translateX(-50%);
        border-radius:0.21rem;
        background:rgba(255,88,103,1);
        white-space: nowrap;
        b {
          font-size:0.12rem;
          font-weight:600;
          color:rgba(255,255,255,1);
          line-height:17px;
          margin-right: 0.1rem;
          display: inline;
          white-space: nowrap;
        }
        span {
          font-size:0.12rem;
          font-weight:300;
          color:rgba(255,255,255,1);
          line-height:17px;
          display: inline;
          white-space: nowrap;
        }
      }
    }
    .my_scroller {
      ul{
        padding: 0.18rem 0.15rem 0.18rem 0.11rem;
        position: relative;
        top: -0.15rem;
        border-radius:0.15rem 0.15rem 0 0;
        background: #fff;
        li{
          display: flex;
          display: -webkit-flex;
          display: -o-flex;
          display: -ms-flex;
          display: -moz-flex;
          position: relative;
          margin-bottom: 0.1rem;
          img{
            width: 1.3rem;
            height: 1.3rem;
            flex-shrink: 0;
            -webkit-flex-shrink: 0;
            -ms-flex-shrink: 0;
            -moz-flex-shrink: 0;
            -o-flex-shrink: 0;
          }
          .tagimg {
            width:0.49rem;
            height:0.28rem;
            position: absolute;
            left: -0.04rem;
            top: 0.08rem;
          }
          .proContent {
            margin-top: 0.01rem;
            margin-left: 0.11rem;
            position: relative;
            flex: 1;
            -webkit-flex: 1;
            -o-flex: 1;
            -ms-flex: 1;
            -moz-flex: 1;
            >p {
              font-size:0.14rem;
              font-weight:400;
              color:rgba(41,41,41,1);
              line-height:0.2rem;
              height: 0.4rem;
            }
            >img {
              position: absolute;
              right: 0;
              bottom: 0;
              width:0.26rem;
              height:0.26rem;
            }
            .tags {
              display: flex;
              display: -moz-flex;
              display: -ms-flex;
              display: -o-flex;
              display: -webkit-flex;
              flex-wrap: wrap;
              -moz-flex-wrap: wrap;
              -ms-flex-wrap: wrap;
              -o-flex-wrap: wrap;
              -webkit-flex-wrap: wrap;
              margin: 0.03rem 0 0;
              max-height: 0.44rem;
              b {
                display: flex;
                display: -moz-flex;
                display: -ms-flex;
                display: -o-flex;
                display: -webkit-flex;
                padding: 0 0.07rem;
                font-size:0.12rem;
                font-weight:400;
                color:rgba(255,101,90,1);
                line-height:0.19rem;
                height:0.19rem;
                border-radius:0.1rem;
                border:1px solid rgba(255,101,90,1);
                margin-right: 0.04rem;
                white-space: nowrap;
                margin-bottom: 0.03rem;
              }
              img {
                width: 0.12rem;
                height: 0.12rem;
                margin-top: 0.02rem;
              }
            }
            .salesStatus {
              display: block;
              font-size:0.11rem;
              font-weight:400;
              color:rgba(153,153,153,1);
              line-height:0.16rem;
              margin-bottom: 0.06rem;
            }
            .span {
              display: block;
              /*margin-bottom: 0.06rem;*/
              overflow: hidden;
              font-size: 0;
              position: absolute;
              left: 0;
              bottom: 0;
              .goods_price{
                display: inline-block;
                &.nowPrice {
                  padding-right: 0.06rem;
                  font-size: 0.2rem;
                  font-weight:600;
                  color:#FC0324;
                  /*line-height: 0.21rem;*/
                  .smallprice {
                    font-size: 0;
                    b {
                      font-size: 0.2rem;
                      font-weight:600;
                      color:#FC0324;
                    }
                  }
                  sub {
                    font-size:0.12rem;
                    font-weight:600;
                    vertical-align: baseline
                  }
                  sup {
                    font-size: 0.12rem;
                    vertical-align: baseline;
                    font-weight:600;
                  }
                }
                &.beforePrice {
                  font-size: 0.14rem;
                  font-weight:600;
                  color:#6C6C6C;
                  /*line-height:0.16rem;*/
                  text-decoration: line-through;
                  .smallprice {
                    font-size: 0;
                    b {
                      font-size: 0.12rem;
                      font-weight:600;
                      color:#6C6C6C;
                    }
                  }
                }
              }
              >i {
                margin-left: 0.11rem;
                font-style: normal;
                font-size:0.11rem;
                font-weight:400;
                color:rgba(108,108,108,1);
                line-height:0.16rem;
                text-decoration: line-through ;
              }
            }
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
            }
          }
        }
      }
    }
  }
  .FloatWindow {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 0.1rem 0.11rem 0;
    z-index: 1;
    >p{
      text-align: right;
      right: 0.11rem;
      top: 0.15rem;
      color: #191818;
      font-size: 0.13rem;
      line-height: 0.18rem;
      margin-bottom: 0.21rem;
      img {
        margin: 0.06rem 0 0.06rem 0.04rem;
        width: 0.08rem;
        height: 0.06rem;
        float: right;
      }
    }
    .classification {
      p{
        font-size: 0.12rem;
        color: #979797;
      }
      &:first-of-type ul {
        margin-right: 0.11rem;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        -o-justify-content: space-between;
        -ms-justify-content: space-between;
        -moz-justify-content: space-between;
      }
      &:nth-of-type(2) ul {
        margin-bottom: 0.52rem;
        li {
          margin-right: 0.1rem;
        }
      }
      ul {
        display: flex;
        display: -webkit-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -moz-flex;
        margin: 0.1rem 0 0.15rem 0;
        li {
          font-size: 0.12rem;
          padding: 0.06rem 0.13rem;
          border-radius: 0.15rem;
          &.elements {
            color: #5E5E5E;
            background: #EEEFF4;
            border: 1px solid transparent;
          }
          &.tempElements {
            color: #FC0324;
            border: 1px solid #FC0324;
          }
        }

      }
    }
    .btn {
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -moz-flex;
      position: absolute;
      bottom: -0.46rem !important;
      left: 0;
      right: 0 !important;
      .element {
        display: block;
        width: 50%;
        border: none;
        border-top: 1px solid #EFEFEF;
        outline: none;
        font-size: 0.15rem;
        color: #292929;
        line-height: 0.46rem;
        background: #fff;
        &:last-of-type {
          color: #fff;
          border: none;
          border-top: 1px solid transparent;
          background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -webkit-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -o-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -ms-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -moz-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          border-radius:0 0 0.04rem 0;
        }
      }
    }
  }
  .mask{
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background:rgba(0,0,0,1);
    opacity:0.69;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(-0.5rem);
    opacity: 0;
  }
  .homeBtn {
    z-index: 10;
    position: fixed;
    right:0.17rem;
    bottom:0.6rem;
    width:0.5rem;
    height:0.5rem;
    border-radius: 50%;
    img {
      width: 0.5rem;
      height: 0.5rem;
      display: block;
    }
    .cartnum {
      position: absolute;
      right: 0.1rem;
      top: 0.1rem;
      color: #FFFFFF;
      background: #FC0324;
      font-size: 0.08rem;
      width: 0.1rem;
      height: 0.1rem;
      border-radius: 50%;
      line-height: 0.1rem;
      text-align: center;
    }
  }
</style>
<style lang="scss">
  .bestSell {
    .good_sku {
      .van-icon-cross {
        background: url('../../assets/images/close3.png') no-repeat center;
        background-size: 100%;
        color: transparent;
      }
    }
  }
  .bestSell {
    .good_sku .van-sku-row__item{
      border-radius: .15rem;
      font-size: .13rem;
      color:#5E5E5E;
      padding: 0 .1rem;
      border: solid 1px transparent;
    }
    .good_sku .van-sku-row__item::before{
      background: #EEEFF4;
    }
    .good_sku .van-sku__goods-price{
      margin-top: .2rem;

    }
    .good_sku .van-sku__price-symbol,.van-sku__price-num{
      font-size: .16rem;
      color:#FC0324;
      font-weight: 600;
    }
    .good_sku .van-sku-row__item--active{
      border: solid 1px #FC0324;
      background-color: #FCEDEB;
      color:#FC0324;
    }
    .good_sku .van-sku-row__item-name{
      padding: .06rem;
    }
    .good_sku .van-sku-row__item-img{
      width: .2rem;
      height: .2rem;
    }
    .good_sku.van-popup--bottom.van-popup--round{
      border-radius: 0;
    }
    .good_sku .van-sku-row__title,.van-sku__stepper-title{
      padding-bottom:.13rem;
      font-size: .13rem;
      color:#333333;
      line-height: .18rem;
      font-weight: 600;
    }
    .good_sku .van-sku__stepper{
      border-radius: .13rem;
      overflow: hidden;
    }
    .good_sku .van-stepper__minus, .van-stepper__plus,.van-stepper__input{
      height: .22rem;
    }
    .good_sku .van-stepper__minus::before, .van-stepper__plus::before{
      width: 9px;
    }
    .good_sku .van-stepper__minus::after, .van-stepper__plus::after{
      height: 9px;
    }
    .good_sku .van-sku-row__item--disabled{
      background:#FCFCFC;
      border-radius:.15rem;
      border:1px solid #EEEFF4;
      color:#DEDEDE;
      &:before {
        background:#FCFCFC;
      }
    }
    .pro_details_con {
      font-size: .14rem;
    }
    .pro_details_con img {
      width: 100% !important;
      height: auto !important;
    }
    .pro_details_con .ckeditor-html5-video {
      width: 100%;
    }
    .pro_details_con .ckeditor-html5-video video {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homepage/bestSell.vue